module.exports = __webpack_public_path__ + "img/leme_digital.291ccc67.svg";